import { TiSocialFacebook } from "react-icons/ti";
import { FiFacebook, FiInstagram, FiLinkedin, FiYoutube } from "react-icons/fi";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function TopNavbar() {
  const navigate = useNavigate();
  const socialIcons = [
    {
      name: "facebook",
      icon: FiFacebook,
      link: " https://www.facebook.com/profile.php?id=61565519471893",
    },
    {
      name: "instagram",
      icon: FiInstagram,
      link: " https://www.instagram.com/mixmasters.rmc",
    },
    // { name: "youtube", icon: FiYoutube, link: "https://youtube.com" },
    {
      name: "linkedin",
      icon: FiLinkedin,
      link: " https://www.linkedin.com/company/mixmasters-rmc",
    },
  ];
  return (
    <div className="bg-black text-white text-xs border-b border-gray-700">
      <div className="container mx-auto hidden md:flex items-center justify-between h-[40px] px-6 md:px-10">
        {/* LEFT SIDE */}
        <div className="flex items-center gap-6">
          {/* Email */}
          <div className="flex items-center gap-2 text-gray-300 hover:text-white transition">
            <FaEnvelope className="text-[12px]" />
            <span>sales@mixmasters.in</span>
          </div>

          {/* Divider */}
          <div className="w-[1px] h-4 bg-gray-600"></div>

          {/* Phone */}
          <div className="flex items-center gap-2 text-gray-300 hover:text-white transition">
            <FaPhoneAlt className="text-[12px]" />
            <span>+91 912 4001 120</span>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="flex items-center gap-6">
          {/* Login */}
          <div
            onClick={() =>
              window.open(
                "https://email.mixmasters.in/",
                "_blank",
                "noopener,noreferrer",
              )
            }
            className="flex items-center gap-1 text-gray-300 hover:text-white cursor-pointer transition"
          >
            <span className="font-medium">EMPLOYEE</span>
            <span>LOGIN</span>
          </div>

          {/* Divider */}
          <div className="w-[1px] h-4 bg-gray-600"></div>

          {/* Social Icons */}
          <div className="flex items-center gap-3">
            {socialIcons.map(({ name, icon: Icon, link }) => (
              <div
                key={name}
                className="social-icon cursor-pointer"
                onClick={() =>
                  window.open(link, "_blank", "noopener,noreferrer")
                }
              >
                <Icon className="text-gray-50 size-5" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
